










import { Component, Vue } from 'vue-property-decorator';
import ElementUI from 'element-ui';

import Gotcha from '@/components/Fifth/Gotcha.vue';
import Header from '@/components/Fifth/Header.vue';
import Main from '@/components/Fifth/Main.vue';
import Footer from '@/components/Fifth/Footer.vue';
import SideButton from '@/components/Fifth/SideButton.vue';

import FourthFifthMixin from '@/mixins/FourthFifthMixin';

Vue.use(ElementUI);
Vue.mixin(FourthFifthMixin);

@Component({
  components: {
    Gotcha,
    AppHeader: Header,
    AppMain: Main,
    AppFooter: Footer,
    SideButton
  }
})
export default class Fifth extends Vue {}
